export const DefaultInput = (props) => (
    <input type='text' className={`gray-input form-control ${props.isValid ? "is-valid" : ""}`} value={props.value}
        onChange={(event) => props.onChange(event.target.value || '')} onFocus={props.onFocus} onBlur={props.onBlur}
        maxLength={255}/>
)